module.exports = require('./helpers/bundle-url').getBundleURL('4SxJc') + "code-reviewer-repo-onboarding-img.470dd881.png";